const LEGACY_VISITED_KEY = ' baoubab-visited';
const VISITED_KEY = 'baoubab-visited';
const LEGACY_PERSIST_KEY = ' baoubab-root';
const PERSIST_KEY = 'baoubab-root';

const migrateLegacyKeys = () => {
  const legacyVisited = localStorage.getItem(LEGACY_VISITED_KEY);
  if (legacyVisited !== null) {
    localStorage.setItem(VISITED_KEY, legacyVisited);
    localStorage.removeItem(LEGACY_VISITED_KEY);
  }

  const legacyPersist = localStorage.getItem(`persist:${LEGACY_PERSIST_KEY}`);
  if (legacyPersist !== null && !localStorage.getItem(`persist:${PERSIST_KEY}`)) {
    localStorage.setItem(`persist:${PERSIST_KEY}`, legacyPersist);
    localStorage.removeItem(`persist:${LEGACY_PERSIST_KEY}`);
  }
};

migrateLegacyKeys();

export const SessionManager = {
  VISITED_KEY,

  hasVisited: () => {
    return localStorage.getItem(VISITED_KEY) === 'true';
  },

  markAsVisited: () => {
    localStorage.setItem(VISITED_KEY, 'true');
  },

  resetSession: () => {
    localStorage.removeItem(VISITED_KEY);
    localStorage.removeItem(LEGACY_VISITED_KEY);
  },
};
